import { __commonJSMin as e } from "../../../../../../../_virtual/_rolldown/runtime.js";
import { require_map_object as t } from "./map_object.js";
//#region ../../node_modules/.pnpm/@intercom+intermoji@2.0.3/node_modules/@intercom/intermoji/lib/filter_object.js
var n = /* @__PURE__ */ e(((e, n) => {
	var r = t();
	n.exports = function(e, t) {
		var n = {};
		return r(e, function(e, r) {
			t(e, r) && (n[r] = e);
		}), n;
	};
}));
//#endregion
export default n();
export { n as require_filter_object };
